import React from 'react';
import Cart from '../components/Cart';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

function Cartpage() {
  return (
    <div>
      <Navbar/>
      <Cart/>
      <Footer/>
    </div>
  )
}

export default Cartpage
